export default "__VITE_ASSET__CDvMvrEN__"